import React, { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Apis } from "../../util/Apis";
import axios from "axios";
import jwt_decode from "jwt-decode";
import AuthContext from "./store/AuthContext";
import { setCurrentUser } from "./actions/authentication.action";
import { useNavigate, useParams } from "react-router";
import { CardLogin, ContenidoLogin, LoginContainer, TextError } from "./loginElements";
import { Button, Input, Label } from "../atoms";
import { LuEye, LuEyeClosed } from "react-icons/lu";
import logoclub from "../../assets/imgs/carnavalclub.png"

const Signup = () => {
  const { id } = useParams();
  const { stateUser, dispatch } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const firstName = "";
  const lastName = "";
  const [document, setDocument] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [sala, setSala] = useState([]);
  const [siteInfo, setSiteInfo] = useState(null);

  const [passwordShown1, setPasswordShown1] = useState(false);
  const [passwordShown2, setPasswordShown2] = useState(false);

  const togglePassword1 = () => {
    setPasswordShown1(!passwordShown2);
  };

  const togglePassword2 = () => {
    setPasswordShown2(!passwordShown2);
  };

  const navigate = useNavigate();

  useEffect(() => {
    //console.log('doc : ' + id)
    setDocument(id);

    let salaLs = localStorage.getItem("salaInfo");
    if (salaLs !== undefined && salaLs !== null) {
      setSala(JSON.parse(salaLs));
    }
  }, [id]);

  useEffect(() => {
    getSalas();
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const isLoggedIn = stateUser.isAuthenticated;
  const referer = "/home";

  if (isLoggedIn) {
    return <Navigate to={referer} />;
  }

  const goLogin = () => {
    navigate("/login");
  };

  const onRegister = () => {
    setLoading(true);
    setError("");

    const data = {
      tenant: "wgtcustomer",
      connection: sala.auth,
      //email = "hola@gmail.com"
      firstName: firstName,
      lastName: lastName,
      document: document,
      username: document,
      password: password,
      salaId: sala.salaId,
    };

    if (!/^\d{4}$/.test(password)) {
      setError("El PIN debe ser de 4 dígitos numéricos");
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden");
      setLoading(false);
      return;
    }

    // if (!state.checkedA) {
    //   setError("Debes aceptar las promociones especiales")
    //   setLoading(false)
    //   return
    // }
    //
    // if (!state.checkedB) {
    //   setError("Debes aceptar lapolitica de privacidad de datos")
    //   setLoading(false)
    //   return
    // }

    axios
      .post(Apis.OAUTH + "/oauth/signup", data)
      .then(function (res) {
        if (res.status === 200) {
          const token = res.data.access_token;
          const refreshToken = res.data.refreshToken;
          localStorage.setItem("auth", token);
          localStorage.setItem("wsrf", refreshToken);
          const decodedToken = jwt_decode(token);
          setError("");

          axios
            .post(Apis.CAPP + "/register", data)
            .then((res) => {
              dispatch(setCurrentUser(decodedToken));
              setLoading(false);
            })
            .catch((err) => {
              setLoading(false);
              setLoading(false);
              if (error.response) {
                setError(error.response.data.message);
              } else {
                setError("Hubo un error desconocido");
              }
            });
        }
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response) {
          setError(error.response.data.message);
        } else {
          setError("Hubo un error desconocido");
        }
      });
  };

  function getSalas() {
    axios
      .get(Apis.CAPP + "/site")
      .then(function (response) {
        setSiteInfo(response.data);
      })
      .catch(function (error) {});
  }

  return (
    <>
      {siteInfo && (
        <>
          <LoginContainer>
            <CardLogin isSelect={true}>
              <ContenidoLogin>
                <div className="flex flex-col items-center justify-center w-[120px] h-[120px] bg-white p-0">
                  <img
                    src={logoclub}
                    alt="logo"
                    className="w-auto h-auto max-h-[120px] max-w-[120px] rounded-2xl"
                  />
                </div>

                <form className="flex flex-col w-full gap-4 p-4">
                  <div className="flex flex-col w-full">
                    <Label id="labeldocument">Documento</Label>
                    <Input
                      disabled
                      type="text"
                      id="document"
                      label="Documento"
                      value={document}
                      onChange={(e) => setDocument(e.target.value)}
                    />
                  </div>
                  <div className="relative flex flex-col w-full">
                    <Label id="password">PIN (4 dígitos)</Label>
                    <Input
                      required
                      autoComplete="off"
                      htmlFor="password"
                      type={passwordShown1 ? "text" : "password"}
                      id="password"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength={4}
                      value={password}
                      onChange={(e) => setPassword(e.target.value.replace(/\D/g, "").slice(0, 4))}
                    />
                    <div className="absolute bottom-2.5 right-3.5">
                      {passwordShown1 ? (
                        <LuEye size={18} onClick={togglePassword1} />
                      ) : (
                        <LuEyeClosed size={18} onClick={togglePassword1} />
                      )}
                    </div>
                  </div>

                  <div className="relative flex flex-col w-full">
                    <Label id="repeatpassword">Confirmar PIN</Label>
                    <Input
                      required
                      autoComplete="off"
                      type={passwordShown2 ? "text" : "password"}
                      htmlFor="repeatpassword"
                      id="repeatpassword"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength={4}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value.replace(/\D/g, "").slice(0, 4))}
                    />
                    <div className="absolute bottom-2.5 right-3.5">
                      {passwordShown2 ? (
                        <LuEye size={18} onClick={togglePassword2} />
                      ) : (
                        <LuEyeClosed size={18} onClick={togglePassword2} />
                      )}
                    </div>
                  </div>
                  {/*<CustomCheckbox>*/}
                  {/*  <Form.Check required checked={state.checkedA} onChange={handleChange} name="checkedA"*/}
                  {/*              style={{paddingLeft: "0", marginRight: '0.5rem'}}/>*/}
                  {/*  <label>Deseo recibir información de las <span*/}
                  {/*    onClick={handleShow}>Promociones especiales</span></label>*/}
                  {/*</CustomCheckbox>*/}

                  {/*<CustomCheckbox>*/}
                  {/*  <Form.Check required checked={state.checkedB} onChange={handleChange} name="checkedB"*/}
                  {/*              style={{paddingLeft: "0", marginRight: '0.5rem'}}/>*/}
                  {/*  <label>Ley de Política de <a href={window.location.origin + sala.privacidad}>Privacidad de*/}
                  {/*    datos</a></label>*/}
                  {/*</CustomCheckbox>*/}

                  <TextError>{error && error}</TextError>

                  <div className="flex flex-col w-full gap-2">
                    <Button type="button" onClick={goLogin} variant="outline">
                      Regresar
                    </Button>
                    <Button onClick={onRegister} disabled={loading} type="submit">
                      {loading ? "Cargando" : "Registrarse"}
                    </Button>
                  </div>
                </form>
              </ContenidoLogin>
            </CardLogin>
          </LoginContainer>
          <div show={show} onHide={handleClose} centered backdrop="static" keyboard={false}>
            <div closeButton>
              <span>Promociones Especiales</span>
            </div>
            <div>
              <span>
                Mediante su aceptación usted autoriza a <strong>{sala.company}</strong> (en
                adelante, “<strong>{sala.companyShort}</strong>”), a tratar sus datos personales
                proporcionados en el presente formulario para el envío de (i) saludos por cumpleaños
                y (ii) publicidad referente a promociones, ofertas, invitaciones a eventos y
                servicios de <strong>{sala.companyShort}</strong> a través de medios electrónicos
                y/o físicos y/o mediante llamadas telefónicas. Los datos personales obtenidos en el
                presente formulario quedarán almacenados en el banco de datos de Clientes de{" "}
                <strong>{sala.companyShort}</strong>.
              </span>
            </div>
            <div>
              <button variant="primary" onClick={handleClose}>
                ACEPTAR
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Signup;
